import apiClient from '@u/apiClient'
import CreateQuestionController from '@/wayfinder/actions/App/Http/Controllers/Question/CreateQuestionController'
import UpdateQuestionController from '@/wayfinder/actions/App/Http/Controllers/Question/UpdateQuestionController'
import DeleteQuestionController from '@/wayfinder/actions/App/Http/Controllers/Question/DeleteQuestionController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const baseErrors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    if ('new_id' in payload) {
      payload.successCallback(payload.new_id)
    } else {
      payload.successCallback()
    }
  }
}

export default {
  // region fetch

  fetchNewQuestion({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'question' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // fetchSurveyById({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     apiClient
  //       .get(`survey/${payload.id}`)
  //       .then((response) => {
  //         resolve(response.data)
  //       })
  //       .catch((reason) => {
  //         reject(reason)
  //       })
  //   })
  // },
  // endregion

  // region store
  storeNewQuestion: ({ commit }, payload) => {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateQuestionController.post(), payload.question)
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateQuestion: ({ commit }, payload) => {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateQuestionController.put({ question: payload.id }),
          payload.question
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion
  //
  // // region delete
  deleteQuestionById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteQuestionController.delete.delete({ question: payload.id }))
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // // endregion

  undoDeleteQuestionById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteQuestionController.undo.get({ id: payload.id }))
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
